/**
 * Visitor-visible brand identity, with brand-neutral defaults.
 *
 * White-label posture: no vendor name is compiled into the widget. Every brand
 * string a VISITOR can read comes from here, and every value falls back to a
 * neutral phrase, so a deployment that sets nothing still leaks no product name.
 * Values are supplied at build time via `VITE_BRAND_*`, mirroring `config/env.ts`.
 *
 * Precedence: a per-org setting always wins over these defaults. The footer, for
 * example, prefers `theme.footerCompanyName` and only falls back to
 * `widgetBrand.footerLabel` when the org has configured nothing.
 */
function textOr(value: string | undefined, fallback: string): string {
  return value && value.trim() ? value.trim() : fallback;
}

export const widgetBrand = {
  /** Footer strip text used only when the org has set no company name or logo. */
  footerLabel: textOr(import.meta.env.VITE_BRAND_FOOTER_LABEL, 'Powered by Live Chat'),
  /**
   * Accessible name for the iframe the loader injects into the HOST page.
   * Reaches screen readers, so it is an a11y label first and a brand string second —
   * keep it a plain description of the control, not a product name.
   */
  frameTitle: textOr(import.meta.env.VITE_BRAND_FRAME_TITLE, 'Chat'),
  /** Neutral console tag. Deliberately not brand-derived so log greps stay stable. */
  logTag: '[lc-widget]',
};
